module.exports = __webpack_public_path__ + "static/media/escuela.e9ae5197.png";